// extracted by mini-css-extract-plugin
export var bottom = "styles-module--bottom--b7f4c";
export var compact = "styles-module--compact--69e14";
export var content = "styles-module--content--d40aa";
export var description = "styles-module--description--d7d44";
export var image = "styles-module--image--42c48";
export var title = "styles-module--title--c6ba0";
export var top = "styles-module--top--8e98c";
export var wrapper = "styles-module--wrapper--0a2f2";